/**
 * Copy and dismissal state for the "this build has no realtime client" notice.
 *
 * A build without `VITE_PUSHER_KEY` / `VITE_PUSHER_CLUSTER` opens no socket at
 * all (`lib/echo.ts` returns null rather than guessing a key). That is not an
 * outage: the API answers, the pages load, only live pushes are missing. The
 * clinic must be told exactly that — never that the server is unreachable —
 * and must be able to put the notice away for the session.
 *
 * The key lives in `sessionStorage`, not `localStorage`: the next session
 * should see the notice again, because the state it describes is a deployment
 * gap somebody is expected to close.
 */
export const REALTIME_DISABLED_NOTICE = "Atualizações em tempo real desativadas";

export const REALTIME_DISABLED_DISMISS_LABEL = "Dispensar aviso";

export const REALTIME_DISABLED_DISMISS_KEY = "clinisharp.realtime-disabled-notice-dismissed";

/**
 * Storage access throws when the browser blocks it (private mode, embedded
 * webviews). The notice is cosmetic, so a blocked store means "not dismissed"
 * instead of an exception thrown from the top of the app tree.
 */
export function realtimeNoticeDismissed(): boolean {
  try {
    return window.sessionStorage.getItem(REALTIME_DISABLED_DISMISS_KEY) === "1";
  } catch {
    return false;
  }
}

export function dismissRealtimeNotice(): void {
  try {
    window.sessionStorage.setItem(REALTIME_DISABLED_DISMISS_KEY, "1");
  } catch {
    // Ignored: the caller hides the notice from component state anyway.
  }
}
